// Làm sạch HTML hiển thị nội tuyến (dùng cho thẻ Word — nội dung tin cậy vừa phải).
// Lưu ý: thẻ HTML thô (HtmlCard) KHÔNG dùng hàm này mà chạy trong <iframe sandbox>
// để cô lập hoàn toàn script của giáo viên khỏi ứng dụng chính.
export function sanitizeInlineHtml(html: string): string {
  if (!html) return ''
  let out = html
  // Bỏ thẻ <script>...</script>
  out = out.replace(/<script[\s\S]*?<\/script>/gi, '')
  // Bỏ thẻ <iframe> nội tuyến (iframe chỉ dùng có kiểm soát ở các thẻ chuyên dụng)
  out = out.replace(/<iframe[\s\S]*?<\/iframe>/gi, '')
  // Bỏ handler sự kiện inline: onClick=, onload=, ...
  out = out.replace(/\son\w+\s*=\s*"[^"]*"/gi, '')
  out = out.replace(/\son\w+\s*=\s*'[^']*'/gi, '')
  // Bỏ javascript: trong href/src
  out = out.replace(/(href|src)\s*=\s*"javascript:[^"]*"/gi, '$1="#"')
  return out
}
